import React from 'react';
import { Link, NavLink, Redirect } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';

export class Header extends React.Component {
    constructor(props) {
        super();
        this.state = {
            scrolled: true,
            expanded: false,
            subMenu: [false, false],
            pageMenu: [],
            headerDto: {},
            keywords: "",
            isEnterPress: false,
            host: window.location.origin + process.env.REACT_APP_BASE_NAME
        };
        this.expandSubMenu = this.expandSubMenu.bind(this);
        this.expandMenu = this.expandMenu.bind(this);
        this.trackScrolling = this.trackScrolling.bind(this);
        this.siteSearch = this.siteSearch.bind(this)
    }

    getPageMenu() {
        fetch(process.env.REACT_APP_API_URL + '/Pages/GetPageForMenu', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*',
                'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
            }
        })
            .then(res => res.json())
            .then((data) => {
                if (data.isSuccess) {
                    this.setState({ headerDto: data.headerDto });
                    this.setState({ pageMenu: data.pages });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    componentDidMount() {
        var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
        if (scrollPos > 0) {
            this.setState({ scrolled: false });
        }
        window.addEventListener('scroll', this.trackScrolling);

        this.getPageMenu();

    }
    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.trackScrolling);
    }

    expandSubMenu = (index) => {

        let subMenu = this.state.subMenu;
        subMenu[index] = !subMenu[index];
        this.setState({ subMenu: subMenu });
    }

    expandMenu = () => {
        if (this.state.expanded) {
            var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
            if (scrollPos > 0) {
                this.setState({ expanded: false, scrolled: false });
            } else {
                this.setState({ expanded: false, scrolled: true });
            }
        } else {
            this.setState({ expanded: !this.state.expanded, scrolled: false });
        }

    }

    trackScrolling = (e) => {
        var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
        if (scrollPos > 0) {
            this.setState({ scrolled: false });
        } else {
            this.setState({ scrolled: true });
        }
        // const window = e.currentTarget;
        // if (this.prev > window.scrollY) {
        //     this.setState({ scrolled: true });
        // } else if (this.prev < window.scrollY) {
        //     this.setState({ scrolled: false });
        // }
        // this.prev = window.scrollY;
    };

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (this.state.keywords) {
                this.setState({ isEnterPress: true });
            }
        }
    }

    siteSearch = (e) => {
        this.setState({ keywords: e.target.value });
    }

    render() {
        // let IsScrolled = this.state.scrolled && window.innerWidth > 991;
        let headerDto = this.state.headerDto;
        let pageMenu = this.state.pageMenu;
        let IsExpended = this.state.expanded;
        let IsScrolled = this.state.scrolled && !IsExpended;
        let subMenu = this.state.subMenu;
        let isEnterPress = this.state.isEnterPress;
        if (isEnterPress) {
            window.location.href = `${this.state.host}SiteSearch/${this.state.keywords}`;
            //return (<Redirect to={`/depositapplication/single`} />);
        }

        return (
            <div id="Header" className="w-100">
                <section id="sgds">
                    <div className="sgds-masthead">
                        <div className="container overflow-hidden">
                            <div className="row">
                                <div className="col">
                                    <a href="https://www.gov.sg" target="_blank" rel="noreferrer">
                                        <span className="sgds-icon sgds-icon-sg-crest"></span>
                                        <span className="is-text">A Singapore Government Agency Website</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className={IsScrolled ? 'container-fluid custom-nav header-dark' : 'container-fluid custom-nav bg-white header-white'}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 px-0 pt-3 pb-2 d-flex flex-row justify-content-between flex-grow-1" >
                                <NavLink to={'/'}><img className="logo" alt="" src={IsScrolled ? headerDto.image : headerDto.imageScrolled} style={{ 'flexBasis': '100%' }} /></NavLink>
                                <ul className="list-unstyled m-0 ml-md-4 main-menu d-xl-flex flew-row align-items-end d-none">
                                    {pageMenu && pageMenu.sort((a, b) => (a.sequence > b.sequence) ? 1 : -1).map((data, index) => {
                                        if (data.child.length > 0) {
                                            return (
                                                <li key={index}>
                                                    <NavLink exact={data.sequence === 1 ? true : false} to={data.sequence === 1 ? '/' : `/${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`} activeClassName="active" className="d-flex flex-row align-items-end"><span dangerouslySetInnerHTML={{ __html: data.displayName }}></span><div className="material-icons">expand_more</div></NavLink>
                                                    <ul className="list-unstyled m-0">
                                                        {/* <li><NavLink {...data.sequence === 1 ? 'exact' : ''} activeClassName="active" to={data.sequence === 1 ? '/' : `${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`}><div>{data.name.replaceAll("<br/>", " ")}</div></NavLink></li> */}
                                                        {data.child.sort((a, b) => (a.sequence > b.sequence) ? 1 : -1).map((child, child_index) => {
                                                            return (
                                                                <li key={child_index}>
                                                                    {child.behavior === 'scroll' && child.name !== 'Activities' && <HashLink
                                                                        scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'center' })} to={data.sequence === 1 ? `/${'#' + child.scrollId}` : `/${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}${'#' + child.scrollId}`}>
                                                                        {child.name}</HashLink>}
                                                                    {child.behavior === 'scroll' && child.name === 'Activities' && <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'center' })} to={`/TheOBSExperience${'#3e09bc41-ef0e-4260-78ad-08d9523ccb2d'}`}>{child.name}</HashLink>}
                                                                    {child.behavior === 'redirect' && <NavLink activeClassName="active"
                                                                        to={{
                                                                            pathname: `/${child.name.replaceAll("<br/>", "").replaceAll(" ", "")}`,
                                                                        }}>

                                                                        {child.name}</NavLink>}
                                                                </li>
                                                            )
                                                        })
                                                        }
                                                    </ul>
                                                </li>
                                            )
                                        }
                                        if (data.child.length <= 0) {
                                            return (
                                                <li key={index}>
                                                    {data.sequence === 1 && <NavLink exact activeClassName="active" to={data.sequence === 1 ? '/' : `/${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`}><span dangerouslySetInnerHTML={{ __html: data.displayName }}></span>
                                                    </NavLink>}
                                                    {data.sequence !== 1 && <NavLink activeClassName="active" to={data.sequence === 1 ? '/' : `/${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`}><span dangerouslySetInnerHTML={{ __html: data.displayName }}></span>
                                                    </NavLink>}
                                                </li>
                                            )
                                        }
                                    })
                                    }
                                    <li>
                                        <div className="d-xl-flex">
                                            {headerDto.link && <a rel="noopener noreferrer" target="_blank" className={IsScrolled ? 'btn btn-outline-light rounded-pill px-4 text-nowrap' : 'btn btn-outline-dark rounded-pill px-4 text-nowrap'} href={headerDto.link}>{headerDto.linkText}</a>}
                                            <div id="nav-icon3" className={IsScrolled ? IsExpended ? 'open d-none d-xl-block ml-3' : 'd-none d-xl-block ml-3' : IsExpended ? 'open black d-none d-xl-block ml-3' : 'black d-none d-xl-block ml-3'} onClick={this.expandMenu}>
                                                <span className={IsExpended ? '' : 'initial'}></span>
                                                <span className={IsExpended ? '' : 'initial'}></span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className="d-flex align-items-center d-xl-none">
                                    <div id="nav-icon4" className={IsScrolled ? IsExpended ? 'open' : '' : IsExpended ? 'open black' : 'black'} onClick={this.expandMenu}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>

                            <div className={IsExpended ? 'col-md-12 d-xl-none d-block mobileMenu active p-0' : 'col-md-12 d-xl-none d-block mobileMenu p-0'}>
                                <ul className="list-unstyled pl-1 mt-3">
                                    <li>
                                        <div className="w-100 d-flex flex-row flex-grow-1 mobileSearch">
                                            <div className="d-flex" style={{ flexBasis: '100%' }}>
                                                <label htmlFor="search" className="w-100 m-0">
                                                    <input type="text" id="search" onChange={(e) => this.siteSearch(e)} className="sitesearch form-control w-100 h-100" placeholder="What are you looking for?" autoComplete="off" />
                                                </label>
                                            </div>
                                            <div className="d-flex align-items-center ml-3">
                                                <a href={this.state.host + 'SiteSearch/' + this.state.keywords} className="btn rounded-pill bg-btn-theme color-theme font-weight-bold px-3">Search</a>
                                            </div>
                                        </div>
                                    </li>
                                    {pageMenu && pageMenu.sort((a, b) => (a.sequence > b.sequence) ? 1 : -1).map((data, index) => {
                                        if (data.child.length > 0) {
                                            return (
                                                // onClick={() => this.expandSubMenu(index)}
                                                <li key={index}>
                                                    <NavLink {...data.sequence === 1 ? 'exact' : ''} onClick={this.expandMenu} to={data.sequence === 1 ? '/' : `/${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`} activeClassName="active" className="dropdown-title d-flex flex-row align-items-end"><div dangerouslySetInnerHTML={{ __html: data.displayName }}></div><div className="material-icons ">expand_more</div></NavLink>
                                                    {/* {subMenu[index] &&  */}
                                                    <ul className="list-unstyled m-0">
                                                        {/* <li><NavLink {...data.sequence === 1 ? 'exact' : ''} activeClassName="active" to={data.sequence === 1 ? '/' : `${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`}><div>{data.name.replaceAll("<br/>", " ")}</div></NavLink></li> */}
                                                        {data.child.sort((a, b) => (a.sequence > b.sequence) ? 1 : -1).map((child, child_index) => {
                                                            return (
                                                                <li key={child_index}>
                                                                    {child.behavior === 'scroll' && child.name !== 'Activities' && <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'center' })} onClick={this.expandMenu}
                                                                        to={data.sequence === 1 ? `/${'#' + child.scrollId}` : `/${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}${'#' + child.scrollId}`}>

                                                                        {child.name}</HashLink>}
                                                                    {child.behavior === 'scroll' && child.name === 'Activities' && <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'center' })} onClick={this.expandMenu}
                                                                        to={`/TheOBSExperience${'#3e09bc41-ef0e-4260-78ad-08d9523ccb2d'}`}>{child.name}</HashLink>}
                                                                    {child.behavior === 'redirect' && <NavLink onClick={this.expandMenu} activeClassName="active"
                                                                        to={{
                                                                            pathname: `/${child.name.replaceAll("<br/>", "").replaceAll(" ", "")}`,
                                                                        }}>

                                                                        {child.name}</NavLink>}
                                                                </li>
                                                            )
                                                        })
                                                        }
                                                    </ul>
                                                </li>
                                            )
                                        }
                                        if (data.child.length <= 0) {
                                            return (
                                                <li key={index}>
                                                    {data.sequence === 1 && <NavLink exact onClick={this.expandMenu} activeClassName="active" to={data.sequence === 1 ? '/' : `${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`}><span dangerouslySetInnerHTML={{ __html: data.displayName }}></span></NavLink>}
                                                    {data.sequence !== 1 && <NavLink onClick={this.expandMenu} activeClassName="active" to={data.sequence === 1 ? '/' : `${data.name.replaceAll("<br/>", "").replaceAll(" ", "")}`}><span dangerouslySetInnerHTML={{ __html: data.displayName }}></span></NavLink>}
                                                </li>
                                            )
                                        }
                                    })
                                    }
                                    {headerDto.link && <li><a rel="noopener noreferrer" target="_blank" className={IsScrolled ? 'btn btn-outline-light rounded-pill px-4 text-nowrap' : 'btn btn-outline-dark rounded-pill px-4 text-nowrap'} href={headerDto.link}>{headerDto.linkText}</a></li>}
                                </ul>
                            </div>
                        </div>
                    </div>
                    {IsExpended && <div className="row" onKeyDown={this._handleKeyDown}>
                        <div className={IsExpended ? 'col-md-12 d-xl-block d-none mobileMenu active p-0' : 'col-md-12 d-xl-block d-none mobileMenu p-0'}>
                            <div className="container p-0">
                                <div className="row m-0">
                                    <div className="col-md-12 py-3 d-flex flex-row flex-grow-1">
                                        <div className="d-flex" style={{ flexBasis: '100%' }}>
                                            <label htmlFor="search" className="w-100 m-0">
                                                <input type="text" id="search" className="sitesearch form-control w-100 h-100 border-0" onChange={(e) => this.siteSearch(e)} placeholder="What are you looking for?" autoComplete="off" />
                                            </label>
                                        </div>
                                        <div className="d-flex align-items-center ml-3">
                                            <a href={`${this.state.host}SiteSearch/${this.state.keywords}`} className="btn rounded-pill bg-btn-theme color-theme font-weight-bold px-3">Search</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }
}

